import { BreadcrumbI } from '../Breadcrumbs';

export interface GeneralAdsPageProps {
  transformedObj: {
    filter: { [key: string]: boolean | string };
    sorting?: string;
  };
  setErrorUI: (value: boolean) => void;
  h1?: string;
  totalAdsCount?: number;
  breadcrumbs?: BreadcrumbI[];
}

export enum PriceViewMode {
  PerArea = 'perArea',
  PerAcre = 'perAcre'
}

export interface ToggleOption {
  id: PriceViewMode;
  name: string;
}
